import React from "react";
import { experience } from "../data";

export default function Experience() {
  return (
    <section id="experience" className="bg-gray-900">
      <div className="container mx-auto px-6 py-20">
        <h2 className="text-3xl font-bold text-gray-100 mb-2">
          Industry Experience
        </h2>
        <p className="text-gray-500 mb-12 max-w-2xl">
          Roles where I contributed to real-world software projects.
        </p>
        <div className="space-y-8">
          {experience.map((exp) => (
            <div
              key={exp.company}
              className="bg-gray-800 rounded-lg p-8 border border-gray-700"
            >
              <div className="flex flex-wrap items-baseline justify-between mb-4">
                <div>
                  <h3 className="text-xl font-semibold text-gray-100">
                    {exp.role}
                  </h3>
                  <p className="text-indigo-400 font-medium">{exp.company}</p>
                </div>
              </div>
              <p className="text-gray-400 mb-6 leading-relaxed">
                {exp.description}
              </p>
              {exp.testimonial && (
                <div className="border-l-4 border-indigo-500 pl-4 mt-4">
                  <p className="text-gray-500 italic text-sm leading-relaxed">
                    "{exp.testimonial.quote}"
                  </p>
                  <p className="text-gray-400 text-sm mt-2">
                    — {exp.testimonial.author}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Experience.js